import { render, staticRenderFns } from "./BCDRecords.vue?vue&type=template&id=568f99ae&scoped=true"
import script from "./BCDRecords.vue?vue&type=script&lang=js"
export * from "./BCDRecords.vue?vue&type=script&lang=js"
import style0 from "./BCDRecords.vue?vue&type=style&index=0&id=568f99ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f99ae",
  null
  
)

export default component.exports